function Tabs() {
  const bindAll = function() {
    const menuElements = document.querySelectorAll('[data-tab]')
    for(let i = 0; i < menuElements.length ; i++) {
      menuElements[i].addEventListener('click', change, false)
    }
  }

  const clear = function() {
    const menuElements = document.querySelectorAll('[data-tab]')
    for(let i = 0; i < menuElements.length ; i++) {
      menuElements[i].classList.remove('active')
      const id = menuElements[i].getAttribute('data-tab')
      document.getElementById(id).classList.remove('active-tab')
      document.getElementById(id).classList.remove('active')
    }
    //Remove active Class from Dashboard
    const firstElement = document.querySelector(".account-navigation-links").firstElementChild
    firstElement.querySelector("a").classList.remove('active')
  }

  const change = function(e) {
    clear()
    e.target.classList.add('active')
    const id = e.currentTarget.getAttribute('data-tab')
    document.getElementById(id).classList.add('active-tab')
    const editLink = document.getElementById(id).querySelector(".edit-link")
    if (editLink) {
      editLink.style.display = "none";
    }
    document.querySelector('body').classList.add("scrolled_down")
    document.querySelector('body').classList.remove("scrolled_up")

    const editAccount = document.getElementById(id).querySelector(".edit-account-details-wrap")
    if (editAccount) {
      editAccount.style.display = "block";
    }
    const accountDetails = document.getElementById(id).querySelector(".account-details")
    if (accountDetails) {
      accountDetails.style.display = "none";
    }
    document.getElementById(id).style.border = "none"
  }

  bindAll()

}

const connectTabs = new Tabs()